/* src/app/account/partials/prospects/prospects.component.scss */
/*# sourceMappingURL=prospects.component.css.map */
